import React from 'react';

import { useCurrentuser } from '@uplift/contexts';
import { useFeatureFlag, useIsMobile, useIsCollaborativePhysician } from '@uplift/hooks';
import { ProviderMedicalRole, UserRole } from '@uplift/types';

import {
  ProviderDesktopNavigation, ProviderDesktopNavigationProps
} from './ProviderDesktopNavigation';
import {
  ProviderMobileNavigation, ProviderMobileNavigationProps
} from './ProviderMobileNavigation';

export type ProviderNavigationProps = ProviderMobileNavigationProps & ProviderDesktopNavigationProps;


export const ProviderNavigation: React.FC<ProviderNavigationProps> = (props) => {
  const me = useCurrentuser();
  const isMobile = useIsMobile();
  const PROVIDER_FINANCE_PAGE = useFeatureFlag('PROVIDER_FINANCE_PAGE');
  const IN_APP_MESSAGING = useFeatureFlag('IN_APP_MESSAGING');

  const isCollaborativePhysician = useIsCollaborativePhysician();

  const showFinanceLink = React.useMemo(() => {
    if (me.role === UserRole.provider && PROVIDER_FINANCE_PAGE) {
      if (me.medicalRole === ProviderMedicalRole.psychiatrist) {
        return true;
      } else if (me.fullTime === false && !me.rules?.msoGroup) {
        return true;
      }
    }

    return false;
  }, [me, PROVIDER_FINANCE_PAGE]);

  const showSuperviseesLink = isCollaborativePhysician;

  if (isMobile) {
    return <ProviderMobileNavigation {...props} showFinanceLink={showFinanceLink} showSuperviseesLink={showSuperviseesLink} variant={props.variant || 'elevation'} showMessages={IN_APP_MESSAGING ?? false} />;
  }

  return <ProviderDesktopNavigation {...props} showFinanceLink={showFinanceLink} showSuperviseesLink={showSuperviseesLink} showMessages={IN_APP_MESSAGING ?? false} />;
};
